import React, { useRef, useState } from 'react';
import "../../Css/Home/HomeReview.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaQuoteRight } from "react-icons/fa";

import user01 from "../../Images/home/review/user2.jpg";

import company01 from "../../Images/home/company/brand-logo-01.png";
import company02 from "../../Images/home/company/brand-logo-02.png";
import company03 from "../../Images/home/company/brand-logo-03.png";
import company04 from "../../Images/home/company/brand-logo-04.png";
import company05 from "../../Images/home/company/brand-logo-05.png";
import company06 from "../../Images/home/company/brand-logo-06.png";
import company07 from "../../Images/home/company/brand-logo-07.webp";
const HomeReview = () => {
    return (
        <div>
            <section className='home-section-review'>
                <div className='container'>
                    <div className='home-section-review-main-con'>
                        <div className='home-section-review-con'>
                            <Swiper
                                spaceBetween={30}
                                centeredSlides={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    clickable: true,
                                }}
                                navigation={true}
                                modules={[Autoplay, Pagination, Navigation]}
                                className="mySwiper"
                            >
                                <SwiperSlide>
                                    <div className='home-section-review-swiper-con'>
                                        <div className='home-section-review-swiper-image-main-con'>
                                            <div className='home-section-review-swiper-image'>
                                                <img src={user01} alt='' />
                                            </div>
                                        </div>
                                        <h3>John Duff</h3>
                                        <h4>- Web Developer/Designer</h4>
                                        <div className='home-section-review-swiper-image-icons-main-con'>
                                            <FaQuoteRight />
                                        </div>
                                        <p>"Cajority have suffered alteration in aome from, by injected believable.There varation words able s, but also the leap into electronic typesetting, 1960s with the release of Letraset sheetpassage."</p>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
            <section className='home-section-review-swiper-below-company-section'>
                <div className='continer'>
                    <div className='home-section-review-swipe-below-company-logo-main-con'>
                        <div className='home-section-review-swipe-below-company-logo-con'>
                            <Swiper
                                slidesPerView={1}
                                spaceBetween={10}
                                pagination={{
                                    clickable: true,
                                }}
                                breakpoints={{
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 20,
                                    },
                                    768: {
                                        slidesPerView: 4,
                                        spaceBetween: 40,
                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        spaceBetween: 50,
                                    },
                                }}
                                modules={[Pagination]}
                                className="mySwiper"
                            >
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company01} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company02} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company03} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company04} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company05} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company06} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='home-section-review-company-logo-image-con'>
                                        <div className='home-section-review-company-logo-image'>
                                            <img src={company07} alt='company01'/>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HomeReview
